import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { buffetSelector } from 'store/slices/buffetSlice'
import { useNavigate } from 'react-router-dom'
import ScrollPage from 'components/base-ui/ScrollPage'
import InviteFriendsV2 from 'pages/dine-in/pages/InviteFriendsV2'
import BuffetContainer from 'components/buffet/BuffetContainer'

const InviteFriends = () => {
  const buffet = useSelector(buffetSelector)

  const scrollPageRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  return (
    <BuffetContainer>
      <ScrollPage id="invite-friends-page" ref={scrollPageRef}>
        <InviteFriendsV2 qrCode={buffet.qrSharingCoupon} onClickBack={() => navigate(-1)} />
      </ScrollPage>
    </BuffetContainer>
  )
}

export default InviteFriends
